<template>
  <div
    @click.stop="selectComponent(model)" 
    @contextmenu="onShowContextMenu"
    :id="this.model.$ID"
    :class="
      evaluateClasses(
        classes,
        isInEditorMode ? 'dr-tabs-layout-editor-mode' : ''
      )
    "
  >
    <portal to="action-buttons" v-if="isSelected">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn :disabled='readonly' v-on="on" text color="error" @click="deleteTabs">
            <font-awesome-icon :icon="['fal', 'trash-alt']" size="lg"/>
          </v-btn>
        </template>
        <span>{{ $t("vuetifyWidgets.common.remove") }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn :disabled="readonly" v-on="on" text color="success" @click="onAddTab">
            <font-awesome-icon :icon="['fal', 'plus']" size="lg" />
            <font-awesome-icon :icon="['fal', 'grip-vertical']" size="lg" />
          </v-btn>
        </template>
        <span>{{ $t("vuetifyWidgets.dr-tabs.addColumn") }}</span>
      </v-tooltip>
    </portal>

    <v-container fluid class="pa-0" v-if="isInEditorMode" :class="[ {'dr-tabs-selected': isSelected} ]">
      <div class="dr-tabs-header d-flex justify-center align-center" @click.stop="selectComponent(model)">
        Tabs
      </div>
      <v-tabs v-model="tab" :key="position" :[position]="position" class="dr-tabs-component">
        <v-tab 
          @contextmenu="onShowContextMenu"
          v-for="tabItem in tabs" 
          :key="tabItem.$ID"
          @click.stop="selectComponent(tabItem)"
          :href="'#'+tabItem.$ID"
        >
          <div class="d-flex flex-column">
            <v-icon v-if="tabItem.IconName" :color="tabItem.IconColor" class="mb-1">{{ tabItem.IconName }}</v-icon>
            <span :class="classTabs"> {{ tabItem.Text }} </span>
          </div>
        </v-tab>

        <v-tabs-items v-model="tab" class="dr-tab-place-holder">
          <v-tab-item v-for="tabItem in tabs" :key="tabItem.$ID" :value="tabItem.$ID">
          
            <dr-tab
              :key="tabItem.$ID"
              :tabItem="tabItem"
              :model="tabItem"
              :parentsWidgets="currentListOfParentsWidgets"
              @onAddTab="onAddTab"
              @onDeleteTab="onDeleteTab"
              @modelChanged="onModelChanged"
              :dataSource="dataSource" @callDataSourceAction="$emit('callDataSourceAction', $event)"
            >
            </dr-tab>

          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
      <widgets-context-menu
        v-if="isInEditorMode"
        v-model="showContextMenu"
        :x="x"
        :y="y"
        :snippetCreatable="false"
        :widgetModel="model"
        @deleteComponent="onDeleteComponentFromContextMenu"
        @pasteCopiedWidget="onPasteCopiedWidget"
      />
    </v-container>

    <v-container fluid class="pa-0"  v-else-if="isVisible" >
      <v-tabs v-model="currentTab" :key="position" :[position]="position">

        <v-tab 
          @contextmenu="onShowContextMenu"
          v-for="tabItem in tabs" 
          :key="tabItem.$ID"
          @click.stop="selectComponent(tabItem)"
          :href="'#'+tabItem.$ID"
        >
          <div v-if="isVisible" class="d-flex flex-column">
            <v-icon v-if="tabItem.IconName" :color="tabItem.IconColor" class="mb-1">{{ tabItem.IconName }}</v-icon>
            <span :class="classTabs"> {{ evaluateExpression(tabItem.Text) }} </span>
          </div>
        </v-tab>

        <v-tabs-items v-model="currentTab">
          <v-tab-item v-for="tabItem in tabs" :key="tabItem.$ID" :value="tabItem.$ID">
          
            <dr-tab
              :key="tabItem.$ID"
              :tabItem="tabItem"
              :model="tabItem"
              @onAddTab="onAddTab"
              @onDeleteTab="onDeleteTab"
              @modelChanged="onModelChanged"
              :dataSource="dataSource" @callDataSourceAction="$emit('callDataSourceAction', $event)"
            >
            </dr-tab>

          </v-tab-item>
        </v-tabs-items> 
      </v-tabs>
    </v-container>
  </div>
    
</template>

<script>
import mixin from '../../mixins/base-mixin'
import inputMixin from '../../mixins/input-mixin'
import widgetsWrapperMixin from '../../mixins/widgets-wrapper-mixin'
import contextMenuMixin from '../../mixins/contextmenu-mixin'

export default {
  mixins: [mixin, contextMenuMixin, inputMixin, widgetsWrapperMixin],
  data: () => ({
    tab: '0.9933601282051245'
  }),
  computed: {
    currentTab: {
      get() {
        return this.model.CurrentTab 
          ? this.getDataSourceField(this.model.CurrentTab) 
          : this.tab
      },
      set(val) {
        if (this.model.CurrentTab) {
          this.setDataSourceField(this.model.CurrentTab, val)
        } else {
          this.tab = val
        }
      }
    },
    tabs() {
      if (!this.model.Tabs) {
        return []
      }

      let tabs = []
      // Перебор всех табов, проверка их свойства Visible, для того, чтобы не показывать отключённые табы
      for (let tabIndex = 0; tabIndex < this.model.Tabs.length; tabIndex++) {
        const currentTab = this.model.Tabs[tabIndex]

        if (currentTab.Visible === undefined || currentTab.Visible === '') {
          tabs.push(currentTab)
          continue
        }

        if (typeof currentTab.Visible == 'string') {
          this.evaluateDataExpression(currentTab.Visible) && tabs.push(currentTab)
          continue
        }

        currentTab.Visible && tabs.push(currentTab)
      }

      return tabs
    },
    position() {

      return this.model.TabPosition
    },
    classTabs() {
      return this.model.ClassTabs
    }
  },
  methods: {
    onModelChanged() {
      this.$emit('modelChanged', this.model)
    },
    onDeleteTab() {
      this.model.Tabs = this.model.Tabs.filter((tab) => tab.$ID != this.tab)
      this.tabs = this.model.Tabs

      if (!this.model.Tabs.length) {
        this.deleteTabs()
        return
      }
      this.onModelChanged()
      this.widgetsHelper.setSelectedWidget(undefined)
    },
    onAddTab() {
      let newTab = {
        $ID: Math.random() + '',
        $Type: 'dr-tab',
        Text: 'Tab',
        Widgets: []
      }
      this.model.Tabs.push(newTab)
      this.onModelChanged()
      this.$emit('modelChanged', this.model)
    },
    deleteTabs() {
      this.$emit('deleteComponent', this.model)
    }
  }
}
</script>

<style lang="css" scoped>
  .dr-tabs-layout-editor-mode {
    border: 1px solid #a9a9a9;
    margin: 5px 0;
  }
  .dr-tab-place-holder{
    border: 1px solid #a9a9a9;
    min-height: 50px;
  }
  .dr-tabs-selected {
    outline: 2px solid #ffa500;
    outline-offset: -2px;
  }
  .dr-tabs-header {
    text-align: center;
    background-color: #f0f0f0;
    border-bottom: 1px solid darkgrey;
    height: 15px;
    font-size: 0.7em;
  }
  .dr-tabs-component {
    padding-left: 2px;
    padding-right: 2px;
    padding-bottom: 2px;
  }
</style>
